import React from 'react';
import { Package, ChevronRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { usePendingDeliveries } from '../../hooks/usePendingDeliveries';

export function PendingDeliveries() {
  const navigate = useNavigate();
  const { pendingDeliveries } = usePendingDeliveries();

  // Filtrar solo las entregas no entregadas
  const undeliveredCount = pendingDeliveries.filter(delivery => 
    delivery.delivery_status === 'undelivered'
  ).length;

  if (undeliveredCount === 0) return null;

  return (
    <button 
      onClick={() => navigate('/pending-deliveries')}
      className="w-full bg-orange-50 hover:bg-orange-100 p-4 rounded-lg shadow-sm flex items-center justify-between group"
    >
      <div className="flex items-center gap-3">
        <div className="bg-orange-100 p-2 rounded-full">
          <Package className="w-5 h-5 text-orange-600" />
        </div>
        <div className="font-medium text-orange-900">
          {undeliveredCount} pedido{undeliveredCount !== 1 ? 's' : ''} pendiente{undeliveredCount !== 1 ? 's' : ''} de entrega
        </div>
      </div>
      <ChevronRight className="w-5 h-5 text-orange-600" />
    </button>
  );
} 